import { GridApi } from "ag-grid-community";
import { FC } from "react";
import { Stack } from "@mui/material";
import { AgGridAllFiltersChip } from "@/components/pages/common/ag-grid/components/filters/AgGridAllFiltersChip";
import { AGGridColumnsToolPanel } from "@/components/pages/common/ag-grid/components/AGGridColumnsToolPanel";
import { AgGridGlobalSearch } from "@/components/pages/common/ag-grid/components/global-search/AgGridGlobalSearch";

interface HierarchyAllItemsAgGridToolbarProps {
  gridApi: GridApi | null;
}

export const HierarchyAllItemsAgGridToolbar: FC<
  HierarchyAllItemsAgGridToolbarProps
> = ({ gridApi }) => {
  return (
    <Stack
      p={1.5}
      top={0}
      spacing={2}
      bgcolor="white"
      zIndex="appBar"
      position="sticky"
      direction="row"
      justifyContent="space-between"
    >
      <Stack direction="row" spacing={1} height={32}>
        <AgGridAllFiltersChip gridApi={gridApi} />
      </Stack>

      <Stack
        direction="row"
        justifyContent="end"
        alignItems="center"
        spacing={2}
      >
        <AgGridGlobalSearch sx={{ width: 260 }} gridApi={gridApi} />

        <AGGridColumnsToolPanel gridApi={gridApi} />
      </Stack>
    </Stack>
  );
};
